// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__dKXuh","background_light":"styles_background_light__B9Lgc"};